import script from "./ProductCenterView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCenterView.vue?vue&type=script&setup=true&lang=js"

import "./ProductCenterView.vue?vue&type=style&index=0&id=6aa8220e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa8220e"]])

export default __exports__